const isEmptyObject = (object: any) => {
    // check -> null/undefined
    if (!object) return true;

    return Object.keys(object).length === 0 && object.constructor === Object;
};

export default isEmptyObject;
